export const edgeBandsQuery = /* GraphQL */ `
  query EdgeBandsQuery(
    $sku: String!
    $defaultLanguage: String!
    $query: String
    $filter: [AggregationInput!]
    $after: String
    $first: Int
    $before: String
    $last: Int
  ) {
    edgeBandsQuery(
      sku: $sku
      defaultLanguage: $defaultLanguage
      query: $query
      filter: $filter
      after: $after
      first: $first
      before: $before
      last: $last
    ) {
      aggregations {
        label
        value
        options {
          value
          label
          count
        }
      }
      available {
        pageInfo {
          hasNextPage
        }
        totalCount
        edges {
          node {
            ...PublicEdgeBand
          }
        }
      }
      matching {
        ...PublicEdgeBand
      }
    }
  }

  fragment PublicEdgeBand on PublicEdgeBand {
    id
    parentId
    sku
    name
    thickness
    width
    image {
      id
      filename
      fullpath
    }
    minOrderLength
    price
  }
`;

export const edgeBandQuery = /* GraphQL */ `
  query EdgeBandQuery($sku: String!, $defaultLanguage: String!) {
    edgeBandQuery(sku: $sku, defaultLanguage: $defaultLanguage) {
      id
      parentId
      sku
      name
      thickness
      width
      image {
        id
        filename
        fullpath
      }
      minOrderLength
      price
    }
  }
`;
